export const relativeTimeHe = {
  future: "בעוד %s",
  past: "לפני %s",
  s: "מספר שניות",
  m: "דקה",
  mm: "%d דק'",
  h: "שעה",
  hh: "%d שעות",
  d: "יום",
  dd: "%d ימים",
  M: "חודש",
  MM: "%d חודשים",
  y: "שנה",
  yy: "%d שנים",
};

export const relativeTimeEn = {
  future: "in %s",
  past: "%s ago",
  s: "a few seconds",
  m: "a minute",
  mm: "%d minutes",
  h: "an hour",
  hh: "%d hours",
  d: "a day",
  dd: "%d days",
  M: "a month",
  MM: "%d months",
  y: "a year",
  yy: "%d years",
};
